import * as React from "react";
import * as SliderPrimitive from "@radix-ui/react-slider";
import { cn } from "./utils";

export function Slider({
  className,
  defaultValue,
  value,
  min = 0,
  max = 100,
  rangeClassName,
  rangeStyle,
  thumbClassName,
  ...props
}) {
  const _values = React.useMemo(() => {
    if (Array.isArray(value)) return value;
    if (Array.isArray(defaultValue)) return defaultValue;
    return [min, max];
  }, [value, defaultValue, min, max]);

  return (
    <SliderPrimitive.Root
      data-slot="slider"
      defaultValue={defaultValue}
      value={value}
      min={min}
      max={max}
      className={cn(
        "relative flex w-full touch-none items-center select-none",
        className
      )}
      style={{ height: "20px" }}
      {...props}
    >
      <SliderPrimitive.Track
        data-slot="slider-track"
        className="relative grow rounded-full"
        style={{
          height: "6px",
          width: "100%",
          backgroundColor: "#e5e7eb",
          overflow: "hidden"
        }}
      >
        <SliderPrimitive.Range
          data-slot="slider-range"
          className={cn("absolute h-full rounded-full", rangeClassName)}
          style={{
            height: "100%",
            background: "linear-gradient(to right bottom, #008000, #005000)",
            ...rangeStyle
          }}
        />
      </SliderPrimitive.Track>

      {_values.map((_, index) => (
        <SliderPrimitive.Thumb
          data-slot="slider-thumb"
          key={index}
          className={cn(
            "block rounded-full shadow-md cursor-grab active:cursor-grabbing focus:outline-none transition-all duration-150",
            thumbClassName
          )}
          style={{
            width: "20px",
            height: "20px",
            backgroundColor: "#ffffff",
            border: "2px solid #008000",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)"
          }}
        />
      ))}
    </SliderPrimitive.Root>
  );
}
